export default __webpack_public_path__ + "static/media/Erica_1.7d607489.webp";